import React, { useCallback, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "./index.css"
import _ from "../../_"
import store from "../../store"
import Spinner from "../../components/info/spinner"
import { useGlobal } from '../../context/global'
import DP from '../../components/custom/dp'

const Login = () => {

  const { api } = useGlobal()

  const InitState = 0
  const UserVerificationPending = 1
  const SignInPending = 2

  var [loginState, setLoginState] = useState(InitState)
  var [statusText, setStatusText] = useState("")
  var [buttonText, setButtonText] = useState("Login")

  var phone = useRef()
  var pass = useRef()
  var users = useRef()

  const handleLogin = () => {

    if (!pass.current.value.trim()) {
      toast.error("Empty password!")
      return
    }

    setLoginState(UserVerificationPending)

    api.call("/verify-user", { id: phone.current.value.trim().toPhoneCase(), pass: pass.current.value.trim().hash() })
      .then(res => {
        users.current = res.data
        setLoginState(SignInPending)
        store.set({
          index: 0,
          users: users.current
        }).then(() => {
          window.open(new URL(window.location.href).searchParams.get("redirect") || "/home", "_self")
        }).catch(err => {
          toast.error(err)
        })
      }).catch(err => {
        setLoginState(InitState)
        if (err && err.response && err.response.status == 404) {
          toast.error("This user is not found in our records!")
        } else if (err && err.response && err.response.status == 403) {
          console.log(err)
          toast.error("Incorrect password!")
        } else {
          console.log(err)
          toast.error(`User could not be verified!`)
        }
      })
  }

  useEffect(() => {
    if (loginState == InitState) {
      setStatusText("")
      setButtonText("Login")
    } else if (loginState == UserVerificationPending) {
      setStatusText("Verifying user..")
      setButtonText("Verifying user..")
    } else if (loginState == SignInPending) {
      setStatusText("Signing you in..")
    } else {
      setStatusText("")
    }
  }, [loginState])


  const handleEnterPhone = (e) => {
    if (e.code == "Enter") {
      pass.current.focus()
    }
  }

  const handleEnterPass = (e) => {
    if (e.code == "Enter") {
      handleLogin()
    }
  }


  return (
    <div className="login-container">

      <div className='login-logo-cont'>
        <DP url="/favicon.png" size={[50, 15]} />
      </div>

      <div className='login-status-cont'>
        <div className='login-status'>{statusText}</div>
        {loginState == SignInPending ? <Spinner className="login-spinner" size={5} /> : null}
      </div>

      {loginState < SignInPending ?
        <div className='login-form'>
          <input
            className="login-input"
            ref={phone}
            type={"text"}
            maxLength={10}
            placeholder='Enter reg. WhatsApp num'
            onKeyDown={handleEnterPhone}
          />

          <input
            className="login-input"
            ref={pass}
            type={"password"}
            placeholder='Enter your password'
            onKeyDown={handleEnterPass}
          />

          <button
            className="login-send-button"
            onClick={handleLogin}
          >
            {buttonText}
          </button>


          <div className='login-reset' onClick={() => {
              window.location = "/resetpass"
          }}>Set or Reset Password</div>
        </div> : null
      }

    </div>
  )
}

export default Login